module.exports = __webpack_public_path__ + "media/product/f-5-61089123.png";